module.exports = __webpack_public_path__ + "static/img/EV_SG_Q42024.be71078.jpg";